/** 国际化 + 时区 Pinia store — 语言和时区持久化到 localStorage */
import { defineStore } from 'pinia'
import { ref } from 'vue'

const LANG_KEY = 'tikflow_locale'
const TZ_KEY = 'tikflow_timezone'

export const useLocaleStore = defineStore('locale', () => {
  const locale = ref<string>(localStorage.getItem(LANG_KEY) || 'zh-CN')
  const timezone = ref<string>(localStorage.getItem(TZ_KEY) || 'Asia/Shanghai')

  function setLocale(lang: string) {
    locale.value = lang
    localStorage.setItem(LANG_KEY, lang)
  }

  function setTimezone(tz: string) {
    timezone.value = tz
    localStorage.setItem(TZ_KEY, tz)
  }

  // 后端用户资料是语言的权威来源；时区来自当前企业。
  function syncFromProfile(lang?: string, tz?: string) {
    setLocale(lang === 'en' ? 'en' : 'zh-CN')
    setTimezone(tz || 'Asia/Shanghai')
  }

  return { locale, timezone, setLocale, setTimezone, syncFromProfile }
})
